export default __webpack_public_path__ + "d594db288de5568a14ed5d669d4545a8.png";